/* Arms the entrance and reveals once at 25% visible. Without this file, tiles show fully at rest. */
(function () {
  var sections = document.querySelectorAll('.bdc-vault-tiles');
  if (!sections.length) return;
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-revealed');
      io.unobserve(e.target);
    });
  }, { threshold: 0.25 });
  sections.forEach(function (s) {
    s.classList.add('js-reveal');
    requestAnimationFrame(function () { io.observe(s); });
  });
})();
